import {Component, computed, inject, input} from '@angular/core';
import {ProviderTenderView} from '@frontend/shared-api';
import {ProviderTenderCardChatService} from './provider-tender-card-chat.service';

@Component({
  selector: 'app-provider-tender-card-chat',
  templateUrl: './provider-tender-card-chat.component.html',
})
export class ProviderTenderCardChatComponent {
  private readonly providerTenderCardChatService = inject(ProviderTenderCardChatService);

  readonly tender = input.required<ProviderTenderView>();

  protected readonly chatDisabled = computed(
    () => this.providerTenderCardChatService.loading() || this.providerTenderCardChatService.open(),
  );

  protected readonly showChatButton = computed(
    () => !this.providerTenderCardChatService.isTenderChatClosed(this.tender()),
  );

  protected async onOpenChat(): Promise<void> {
    await this.providerTenderCardChatService.openChat(this.tender().tenderMappingId);
  }
}
